import React from "react";
import {Section} from "../../../../../elements/section/Section";
import {ValidatedInputField} from "../../../../../elements/validator/component/ValidatedInputField";
import {ValidatedSelectField} from "../../../../../elements/validator/component/ValidatedSelectField";
import {useAppDispatch} from "../../../../../../app/hooks";
import {
    updateSettings,
    selectCurrency,
    selectPrice,
    selectStripePublicKey,
    selectStripeSecretKey
} from "../toolSettingsSlice";
import {BotType, Currency, UpdateBotToolSettingsRequest} from "../../../../../../api/generated";
import {DisabledField, isFieldDisabled} from "../../../assistantPreset";
import {
    NotEmptyStringValidator,
    OptionalPositiveNumberValidator,
    StripePublicKeyValidator,
    StripeSecretKeyValidator
} from "../../../../../elements/validator/Validator";
import {ValidationResult} from "../../../../../elements/validator/component/ValidationComponent";
import styles from "../ToolSettingsForm.module.css";
import { allCurrencyOptions } from "../../../modal/createAndUpdate/components/util/currencyUtil";

interface ReservationConfigurationProps {
    botType: BotType;
    updateValidationStatus: (status: ValidationResult<UpdateBotToolSettingsRequest>) => void;
    getMessageWrapper: (f: string) => string;
}

export const ReservationConfiguration: React.FC<ReservationConfigurationProps> = ({
    botType,
    updateValidationStatus,
    getMessageWrapper
}) => {
    const dispatch = useAppDispatch();

    const isReservationDisabled = isFieldDisabled(DisabledField.RESERVATION, botType);

    return (
        <Section title="Reservation Configuration">
            <div className={styles.fieldsLineWithMargin}>
                <ValidatedInputField<string, UpdateBotToolSettingsRequest>
                    required={false}
                    onChange={(v) => dispatch(updateSettings({stripePublicKey: v}))}
                    updateValidationStatus={updateValidationStatus}
                    fieldName={'stripePublicKey'}
                    selector={selectStripePublicKey}
                    validator={StripePublicKeyValidator}
                    disabled={isReservationDisabled}
                    label={'Stripe Public Key'}
                    placeholder={"pk_test_..."}
                    getMessage={getMessageWrapper}
                />
                <ValidatedInputField<string, UpdateBotToolSettingsRequest>
                    required={false}
                    onChange={(v) => dispatch(updateSettings({stripeSecretKey: v}))}
                    updateValidationStatus={updateValidationStatus}
                    fieldName={'stripeSecretKey'}
                    selector={selectStripeSecretKey}
                    validator={StripeSecretKeyValidator}
                    disabled={isReservationDisabled}
                    label={'Stripe Secret Key'}
                    placeholder={"sk_test_..."}
                    getMessage={getMessageWrapper}
                />
            </div>
            <div className={styles.fieldsLineWithMargin}>
                <ValidatedSelectField<Currency, UpdateBotToolSettingsRequest>
                    required={false}
                    onChange={(v) => dispatch(updateSettings({currency: v}))}
                    updateValidationStatus={updateValidationStatus}
                    fieldName={'currency'}
                    selector={selectCurrency}
                    validator={NotEmptyStringValidator}
                    disabled={isReservationDisabled}
                    label={'Currency'}
                    getMessage={getMessageWrapper}
                    options={allCurrencyOptions}
                />
                <ValidatedInputField<number, UpdateBotToolSettingsRequest>
                    required={false}
                    onChange={(v) => dispatch(updateSettings({price: v}))}
                    updateValidationStatus={updateValidationStatus}
                    fieldName={'price'}
                    selector={selectPrice}
                    validator={OptionalPositiveNumberValidator}
                    disabled={isReservationDisabled}
                    label={'Price'}
                    placeholder={"e.g., 100"}
                    getMessage={getMessageWrapper}
                />
            </div>
        </Section>
    );
};

